function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSliderChevronRight = function SvgSliderChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 1.5
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m3.325 2.864 13 13-13 13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 3
    }
  }));
};
export default SvgSliderChevronRight;